export const EstadoPolizaNovedad = [
    {
        nombre: "ACTIVA",
        tipo: "ACTIVA"
    },
    {
        nombre: "RETIRADA",
        tipo: "RETIRADA"
    }
];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/EstadoPolizaNovedad.ts